import GhostOutline from '@/images/GhostOutline.svg';
import styled from '@emotion/styled';

const EmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    min-height: 300px;
    gap: 16px;
    color: ${({ theme }) => theme.colors.black[600]};
`;

const EmptyStateMessage = styled.p`
    font-size: 16px;
    margin: 0;
    text-align: center;
    word-break: break-word;
`;

interface EmptyStateProps {
    searchQuery: string;
}

export const EmptyState = ({ searchQuery }: EmptyStateProps) => (
    <EmptyStateContainer>
        <img src={GhostOutline} alt="" width={32} height={32} />
        {searchQuery ? (
            <EmptyStateMessage>
                We couldn't find templates for <b>"{searchQuery}"</b>.
            </EmptyStateMessage>
        ) : (
            <EmptyStateMessage>We couldn't find templates matching your search.</EmptyStateMessage>
        )}
    </EmptyStateContainer>
);
